module.exports = __webpack_public_path__ + "img/completed-complaints.3301034f.svg";